import { render, staticRenderFns } from "./update-customer-reference.modal.vue?vue&type=template&id=553369e8&"
import script from "./update-customer-reference.modal.vue?vue&type=script&lang=ts&"
export * from "./update-customer-reference.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports